import type { AmazonModuleConfig } from "@/ts/module";

export const amazonConfig: Pick<
	AmazonModuleConfig,
	"apstagConfig" | "maxSlotsPerAuction"
> = {
	apstagConfig: {
		pubID: "3632",
		adServer: "googletag",
		bidTimeout: 2000,
	},
	maxSlotsPerAuction: 10,
};
